import { SVGAttributes } from 'react';

export const Alipay = (props: SVGAttributes<SVGSVGElement>) => {
  return (
    <svg
      width="2914"
      height="732"
      viewBox="0 0 2914 732"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_101_12"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="2914"
        height="732"
      >
        <rect width="2913.71" height="731.775" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_101_12)">
        <path
          d="M622.26 48.8781V575.583H728.718V48.8781H622.26ZM133 575.583H231.386L258.334 476.004H427.501L453.094 575.583H579.085L435.573 66.9114H292.718L133 575.583ZM280.6 393.051L343.924 158.552H346.615L406.591 393.029L280.6 393.051ZM1147.88 580.597C1242.87 580.597 1328.46 505.583 1328.46 372.071C1328.46 252.435 1266.47 180.895 1189.63 180.895C1150.57 180.895 1120.23 196.773 1085.85 227.078V188.812H979.407V698.254H1085.85V571.955C1106.06 577.848 1126.92 580.729 1147.88 580.597ZM1581.18 575.561H1687.66L1674.85 478.863V317.245C1674.85 229.277 1626.33 180.895 1540.72 180.895C1486.17 180.895 1448.42 191.012 1379.69 213.355L1398.54 302.092C1461.23 271.788 1488.86 258.812 1517.82 258.812C1552.88 258.812 1568.35 285.511 1568.35 326.657V329.516C1446.4 354.147 1408.65 367.738 1385.07 392.853C1367.57 411.634 1360.13 438.332 1360.13 469.384C1360.13 543.673 1414.03 583.346 1464.58 583.346C1502.33 583.346 1532.63 568.216 1573.75 535.03L1581.18 575.429V575.561ZM801.491 188.834V575.583H907.97V188.834H801.491ZM2054.22 189.582L2054.92 188.834H1954.52L1891.21 424.059H1887.93L1815.01 188.834H1695.74L1839.25 577.035L1779.27 695.351V698.254H1872.97L2054.22 189.582ZM1149.23 269.676C1188.98 269.676 1220.63 303.544 1220.63 375.721C1220.63 468.087 1174.17 509.19 1122.26 509.19C1109.91 509.34 1097.62 507.388 1085.85 503.406V294.197C1108.11 277.593 1126.31 269.566 1149.21 269.566V269.676H1149.23ZM1463.22 457.993C1463.22 447.151 1465.28 436.309 1473.35 427.644C1486.17 413.965 1511.08 403.871 1568.37 389.444V481.766C1540.06 498.392 1523.9 504.857 1505.02 504.857C1479.39 504.857 1463.22 486.824 1463.22 457.993Z"
          fill="#3E3A39"
        />
        <path
          d="M793.562 95.7648C793.562 133.283 819.155 158.552 854.894 158.552C890.613 158.552 916.205 133.283 916.205 95.7648C916.041 58.9724 890.448 33 854.73 33C818.99 33 793.562 58.9504 793.562 95.7648ZM2781.82 436.771H2540.05C2508.09 436.771 2477.45 423.179 2454.85 398.986C2432.25 374.793 2419.56 341.98 2419.56 307.766H2723.61C2731.25 307.761 2738.82 309.366 2745.88 312.49C2752.94 315.615 2759.35 320.198 2764.76 325.977C2770.16 331.756 2774.45 338.619 2777.38 346.173C2780.31 353.727 2781.82 361.824 2781.82 370.003V436.771Z"
          fill="#1677FF"
        />
        <path
          d="M2177.83 307.766H2360.96V436.771H2236.08C2220.65 436.771 2205.86 430.209 2194.95 418.529C2184.04 406.849 2177.91 391.007 2177.91 374.49V307.634L2177.83 307.766Z"
          fill="#00B6FF"
        />
        <path
          d="M2540.01 111.181V436.727C2524.18 436.738 2508.51 433.411 2493.88 426.936C2479.26 420.461 2465.97 410.964 2454.77 398.989C2443.58 387.013 2434.69 372.793 2428.63 357.141C2422.57 341.489 2419.44 324.711 2419.44 307.766V48.9661H2481.88C2497.29 48.9778 2512.07 55.5386 2522.97 67.2078C2533.87 78.877 2540 94.6784 2540.01 111.181Z"
          fill="#1677FF"
        />
        <path
          d="M2540.05 500.041V695.571H2477.61C2462.18 695.571 2447.38 689.009 2436.48 677.329C2425.57 665.649 2419.44 649.808 2419.44 633.29V500.019L2540.05 500.041Z"
          fill="#00B6FF"
        />
      </g>
    </svg>
  );
};
